module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BAYW0p/tc-custom/9783962727024.jpg",
      "alt": "This image is the cover for the book The Sky Pilot in No Man's Land, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Sky Pilot in No Man's Land, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Excerpt: \"High upon a rock, poised like a bird for flight, stark naked, his satin skin shining like gold and silver in the rising sun, stood a youth, tall, slim of body, not fully developed but with muscles promising, in their faultless, gently swelling outline, strength and suppleness to an unusual degree. Gazing down into the pool formed by an eddy of the river twenty feet below him, he stood as if calculating the distance, his profile turned toward the man who had just emerged from the bushes and was standing on the sandy strand of the river, paddle in hand, looking up at him with an expression of wonder and delight in his eyes.”")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ralph Connor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rev. Dr. Charles William Gordon, or Ralph Connor, (September 13, 1860 – October 31, 1937) was a Canadian novelist, using the Connor pen name while maintaining his status as a Church leader, first in the Presbyterian and later the United Church in Canada. (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae7676c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0